import _type_of from "@swc/helpers/src/_type_of.mjs";
var assertNever = function(x) {
    throw new Error("Unexpected issue: ".concat(x));
};
var joinValues = function(array) {
    var separator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : " | ";
    return array.map(function(value) {
        return typeof value === "string" ? "'".concat(value, "'") : value;
    }).join(separator);
};
var jsonBigIntReplacer = function(_, value) {
    return (typeof value === "undefined" ? "undefined" : _type_of(value)) === "bigint" ? value.toString() : value;
};
export var ErrorMessagesHelper = {
    assertNever: assertNever,
    joinValues: joinValues,
    jsonBigIntReplacer: jsonBigIntReplacer
};

//# sourceMappingURL=ErrorMessagesHelper.js.map